import * as React from 'react';
export const Auth0Context = React.createContext({});
//# sourceMappingURL=auth0Context.js.map